/* eslint-disable */
// Standalone script for the Products Boxes V2 section, kept verbatim from the theme it was built on.
  (() => {
    const PRODUCTS_BOXES_DISCOUNT_STATE_KEY = 'rasa_products_boxes_offer';

    function ensureStylesheet(url) {
      if (!url) return;
      if (document.querySelector(`link[href="${url}"]`)) return;

      const link = document.createElement('link');
      link.rel = 'stylesheet';
      link.href = url;
      link.media = 'print';
      link.onload = function () {
        link.media = 'all';
        link.onload = null;
      };
      document.head.appendChild(link);
    }

    function loadScriptOnce(url) {
      if (!url) return Promise.resolve();

      const existingScript = document.querySelector(`script[src="${url}"]`);
      if (existingScript) {
        if (existingScript.dataset.productsBoxesLoaded === 'true') return Promise.resolve();

        return new Promise((resolve) => {
          existingScript.addEventListener('load', () => {
            existingScript.dataset.productsBoxesLoaded = 'true';
            resolve();
          }, { once: true });
          existingScript.addEventListener('error', () => resolve(), { once: true });
        });
      }

      return new Promise((resolve) => {
        const script = document.createElement('script');
        script.src = url;
        script.async = true;
        script.addEventListener('load', () => {
          script.dataset.productsBoxesLoaded = 'true';
          resolve();
        }, { once: true });
        script.addEventListener('error', () => resolve(), { once: true });
        document.head.appendChild(script);
      });
    }

    function ensureMagicZoomReady(section) {
      if (!section) return Promise.resolve();
      if (window.MagicZoom && typeof window.MagicZoom.refresh === 'function') return Promise.resolve();

      if (window.__productsBoxesMZPReadyPromise) return window.__productsBoxesMZPReadyPromise;

      const cssUrl = section.dataset.mzpCss;
      const additionalCssUrl = section.dataset.mzpAdditionalCss;
      const jsUrl = section.dataset.mzpJs;

      ensureStylesheet(cssUrl);
      ensureStylesheet(additionalCssUrl);

      if (!window.mzOptions) {
        window.mzOptions = {
          zoomWidth: 'auto',
          zoomHeight: 'auto',
          zoomPosition: 'right',
          zoomDistance: 15,
          selectorTrigger: 'click',
          transitionEffect: true,
          zoomMode: 'zoom',
          zoomOn: 'hover',
          zoomCaption: 'off',
          upscale: true,
          variableZoom: false,
          smoothing: true,
          expand: 'off',
          expandZoomMode: 'zoom',
          expandZoomOn: 'click',
          expandCaption: true,
          closeOnClickOutside: true,
          hint: 'once',
          textHoverZoomHint: 'Hover to zoom',
          textClickZoomHint: 'Click to zoom',
          textExpandHint: 'Click to expand',
          textBtnClose: 'Close',
          textBtnNext: 'Next',
          textBtnPrev: 'Previous',
          lazyZoom: false,
          rightClick: false,
        };
      }

      if (!window.mzMobileOptions) {
        window.mzMobileOptions = {
          zoomMode: 'magnifier',
          textHoverZoomHint: 'Touch to zoom',
          textClickZoomHint: 'Double tap to zoom',
          textExpandHint: 'Tap to expand',
        };
      }

      window.__productsBoxesMZPReadyPromise = loadScriptOnce(jsUrl);
      return window.__productsBoxesMZPReadyPromise;
    }

    function parseProductJson(scriptTag) {
      const fallbackData = { labels: [], quote_html: '', quote_various_html: '', order_row: null, seals: [] };
      if (!scriptTag) return fallbackData;

      const rawText = (scriptTag.textContent || '').trim();
      if (!rawText) return fallbackData;

      try {
        return JSON.parse(rawText);
      } catch (error) {
        try {
          const sanitizedText = rawText.replace(/,\s*([}\]])/g, '$1');
          return JSON.parse(sanitizedText);
        } catch (innerError) {
          return fallbackData;
        }
      }
    }

    function parseProductSealsJson(scriptTag) {
      if (!scriptTag) return [];

      const rawText = (scriptTag.textContent || '').trim();
      if (!rawText) return [];

      try {
        const parsed = JSON.parse(rawText);
        return Array.isArray(parsed) ? parsed : [];
      } catch (error) {
        try {
          const sanitizedText = rawText.replace(/,\s*([}\]])/g, '$1');
          const parsed = JSON.parse(sanitizedText);
          return Array.isArray(parsed) ? parsed : [];
        } catch (innerError) {
          return [];
        }
      }
    }

    function parseGiftJson(scriptTag) {
      try {
        return JSON.parse(scriptTag.textContent);
      } catch (error) {
        return { product_id: null, order_row: null };
      }
    }

    function parseBundleMappingJson(scriptTag) {
      const fallbackData = { main_product_id: null, gift_product_id: null, bundle_product_id: null, order_row: null };
      if (!scriptTag) return fallbackData;

      const rawText = (scriptTag.textContent || '').trim();
      if (!rawText) return fallbackData;

      try {
        return JSON.parse(rawText);
      } catch (error) {
        try {
          const sanitizedText = rawText.replace(/,\s*([}\]])/g, '$1');
          return JSON.parse(sanitizedText);
        } catch (innerError) {
          return fallbackData;
        }
      }
    }

    function notifyActiveProductChange(section, card, productData) {
      if (!section || !productData) return;

      const event = new CustomEvent('products-boxes:active-product-change', {
        bubbles: true,
        detail: {
          productsBoxesSectionId: section.id || '',
          activeProductKey: card && card.dataset ? card.dataset.productKey : '',
          productData,
        },
      });

      document.dispatchEvent(event);
    }
let judgeMeReinitTimer = null;

    // Judge.me hydrates its review widget (photos, Q&A tabs) once, on page load, by scanning
    // the DOM for .jdgm-widget elements. Swapping in a different product's widget later (via
    // the products-boxes:active-product-change listener) replaces that DOM node, so it never
    // gets hydrated unless we ask Judge.me to re-scan. Debounced so rapid clicks don't stack
    // multiple loader fetches.
    function reinitJudgeMeReviewWidget() {
      if (!window.jdgm || typeof window.jdgm.loadJS !== 'function' || !window.jdgm.CDN_HOST) return;
      if (judgeMeReinitTimer) return;

      judgeMeReinitTimer = window.setTimeout(() => {
        judgeMeReinitTimer = null;
      }, 500);

      window.jdgm.loadJS(window.jdgm.CDN_HOST + 'loader.js');
    }

    function refreshThirdPartyWidgets(panelContainer) {
      if (window.MagicZoom && typeof window.MagicZoom.refresh === 'function') {
        window.requestAnimationFrame(() => {
          try {
            if (panelContainer) {
              const mzElements = panelContainer.querySelectorAll('.MagicZoomPlus[id]');
              if (mzElements.length) {
                mzElements.forEach((el) => window.MagicZoom.refresh(el.id));
              } else {
                window.MagicZoom.refresh();
              }
            } else {
              window.MagicZoom.refresh();
            }
          } catch (e) {
            // MagicZoom refresh failed, ignore to avoid breaking gallery
          }
          if (panelContainer) {
            if (window.MagicZoom && typeof window.MagicZoom.switchTo === 'function') {
              panelContainer.querySelectorAll('.MagicToolboxContainer').forEach((container) => {
                const firstThumb = container.querySelector('.mz-thumb');
                if (firstThumb && !container.querySelector('.mz-thumb-selected')) {
                  const zoomEl = container.querySelector('.MagicZoomPlus');
                  const zoomId = zoomEl ? zoomEl.getAttribute('id') : null;
                  if (zoomId) {
                    try { window.MagicZoom.switchTo(zoomId, firstThumb); } catch (e2) { /* ignore */ }
                  }
                }
              });
            }
            setupMagicZoomArrowFallback(panelContainer);
          }
        });
      } else if (panelContainer) {
        setupMagicZoomArrowFallback(panelContainer);
      }

      if (window.MagicScroll && typeof window.MagicScroll.refresh === 'function') {
        window.MagicScroll.refresh();
      }

      if (window.jdgm && typeof window.jdgm.loadBadges === 'function') {
        window.jdgm.loadBadges();
      }
    }

    function renderDetails(section, data) {
      const labelsContainer = section.querySelector('[data-active-labels]');
      const quoteContainer = section.querySelector('[data-active-quote]');
      const quoteContainerVarious = section.querySelector('[data-active-quote-various]');
      const detailsContainer = section.querySelector('[data-active-details]');

      if (!labelsContainer || !quoteContainer || !quoteContainerVarious) return;

      labelsContainer.innerHTML = '';

      if (Array.isArray(data.labels)) {
        data.labels.forEach((label) => {
          if (!label) return;
          const labelElement = document.createElement('span');
          labelElement.className = 'products-boxes__label product__specs--feature';
          labelElement.textContent = label;
          labelsContainer.appendChild(labelElement);
        });
      }

      quoteContainer.innerHTML = data.quote_html || '';
      quoteContainerVarious.innerHTML = data.quote_various_html || '';

      if (detailsContainer) {
        const hasLabels = labelsContainer.children.length > 0;
        const hasQuote = quoteContainer.textContent.trim() !== '';
        const hasQuoteVarious = quoteContainerVarious.textContent.trim() !== '';
        detailsContainer.classList.toggle('is-empty', !(hasLabels || hasQuoteVarious));
      }
    }

    function executePanelScripts(panelContainer) {
      if (!panelContainer) return;

      const scripts = Array.from(panelContainer.querySelectorAll('script'));
      scripts.forEach((script) => {
        const scriptType = (script.getAttribute('type') || '').toLowerCase().trim();
        const isJavaScript = scriptType === ''
          || scriptType === 'text/javascript'
          || scriptType === 'application/javascript'
          || scriptType === 'module';

        if (!isJavaScript) return;

        const executableScript = document.createElement('script');
        Array.from(script.attributes).forEach((attr) => {
          executableScript.setAttribute(attr.name, attr.value);
        });
        executableScript.textContent = script.textContent || '';
        script.parentNode.replaceChild(executableScript, script);
      });
    }

    function getMagicZoomSelectors(container) {
      if (!container) return [];

      return Array.from(container.querySelectorAll('.MagicToolboxSelectorsContainer a')).filter((selector) => {
        if (!selector) return false;
        if (selector.style && selector.style.display === 'none') return false;
        if (selector.getAttribute('aria-hidden') === 'true') return false; // exclude Flickity clones
        return true;
      });
    }

    function setActiveMagicZoomSelector(selectors, activeIndex) {
      selectors.forEach((selector, index) => {
        const isActive = index === activeIndex;
        selector.classList.toggle('active-magic-selector', isActive);
        selector.classList.toggle('mz-thumb-selected', isActive);
      });
    }

    function triggerMagicZoomSelector(container, selectors, selectorIndex) {
      if (!container || !selectors.length) return null;

      const targetSelector = selectors[selectorIndex];
      if (!targetSelector) return false;

      const matchingThumb = Array.from(container.querySelectorAll('.mz-thumb'))[selectorIndex];
      if (matchingThumb) {
        const clickEvent = new MouseEvent('click', {
          bubbles: true,
          cancelable: true,
          view: window,
        });
        matchingThumb.dispatchEvent(clickEvent);
        return true;
      }

      setActiveMagicZoomSelector(selectors, selectorIndex);
      const nextSlideId = String(targetSelector.getAttribute('data-slide-id') || 'zoom');
      if (nextSlideId === 'zoom') {
        forceMagicZoomMainImage(container, targetSelector);
        return true;
      }

      activateMagicZoomSlide(container, nextSlideId);

      return true;
    }

    function forceMagicZoomMainImage(container, selector) {
      if (!container || !selector) return;

      const zoomSlide = container.querySelector('.MagicToolboxSlide[data-slide-id="zoom"]');
      const zoomLink = zoomSlide ? zoomSlide.querySelector('.MagicZoomPlus') : null;
      const zoomImage = zoomLink ? zoomLink.querySelector('img') : null;
      if (!zoomLink || !zoomImage) return;

      const href = selector.getAttribute('href');
      const dataImage = selector.getAttribute('data-image');
      const dataImage2x = selector.getAttribute('data-image-2x');
      const dataZoomImage2x = selector.getAttribute('data-zoom-image-2x');
      const selectorImage = selector.querySelector('img');
      const fallbackSrc = selectorImage ? selectorImage.getAttribute('src') : '';
      const fallbackSrcset = selectorImage ? selectorImage.getAttribute('srcset') : '';
      const fallbackAlt = selectorImage ? selectorImage.getAttribute('alt') : '';

      if (href && href !== '#') zoomLink.setAttribute('href', href);
      if (dataImage) zoomLink.setAttribute('data-image', dataImage);
      if (dataImage2x) {
        zoomLink.setAttribute('data-image-2x', dataImage2x);
      } else {
        zoomLink.removeAttribute('data-image-2x');
      }
      if (dataZoomImage2x) {
        zoomLink.setAttribute('data-zoom-image-2x', dataZoomImage2x);
      } else {
        zoomLink.removeAttribute('data-zoom-image-2x');
      }

      const nextSrc = dataImage || fallbackSrc;
      if (nextSrc) zoomImage.setAttribute('src', nextSrc);

      const nextSrcset = dataImage2x ? `${dataImage2x} 2x` : fallbackSrcset;
      if (nextSrcset) {
        zoomImage.setAttribute('srcset', nextSrcset);
      } else {
        zoomImage.removeAttribute('srcset');
      }

      if (fallbackAlt !== null) zoomImage.setAttribute('alt', fallbackAlt || '');

      container.querySelectorAll('.MagicToolboxSlide').forEach((slide) => {
        slide.classList.remove('active-magic-slide');
      });
      if (zoomSlide) zoomSlide.classList.add('active-magic-slide');

      if (window.MagicZoom && typeof window.MagicZoom.refresh === 'function') {
        try {
          if (zoomLink && zoomLink.id) {
            window.MagicZoom.refresh(zoomLink.id);
          } else {
            window.MagicZoom.refresh();
          }
        } catch (e) {
          // ignore
        }
      }
    }

    function activateMagicZoomSlide(container, slideId) {
      if (!container || !slideId) return;

      const slides = Array.from(container.querySelectorAll('.MagicToolboxSlide'));
      if (!slides.length) return;

      slides.forEach((slide) => {
        const isActive = String(slide.getAttribute('data-slide-id') || '') === String(slideId);
        slide.classList.toggle('active-magic-slide', isActive);
      });
    }

    function moveMagicZoomByArrow(container, direction) {
      const activeThumb = container.querySelector('.mz-thumb-selected') || container.querySelector('.mz-thumb');
      if (activeThumb) {
        let nextThumb = direction > 0 ? activeThumb.nextElementSibling : activeThumb.previousElementSibling;

        if (!nextThumb) {
          nextThumb = direction > 0
            ? container.querySelector('.mz-thumb')
            : (activeThumb.parentElement ? activeThumb.parentElement.lastElementChild : null);
        }

        if (nextThumb && nextThumb.classList && nextThumb.classList.contains('mz-thumb')) {
          const allThumbs = Array.from(container.querySelectorAll('.mz-thumb'));
          const nextIndex = allThumbs.indexOf(nextThumb);
          const clickEvent = new MouseEvent('click', {
            bubbles: true,
            cancelable: true,
            view: window,
          });
          nextThumb.dispatchEvent(clickEvent);
          setActiveMagicZoomSelector(getMagicZoomSelectors(container), nextIndex);
          syncThumbSliderToIndex(container, nextIndex);
          return;
        }
      }

      const selectors = getMagicZoomSelectors(container);
      if (!selectors.length) return;

      let activeIndex = selectors.findIndex((selector) => (
        selector.classList.contains('active-magic-selector')
        || selector.classList.contains('mz-thumb-selected')
      ));

      if (activeIndex < 0) {
        const activeSlide = container.querySelector('.MagicToolboxSlide.active-magic-slide');
        const activeSlideId = activeSlide ? String(activeSlide.getAttribute('data-slide-id') || '') : '';
        if (activeSlideId) {
          activeIndex = selectors.findIndex((selector) => (
            String(selector.getAttribute('data-slide-id') || '') === activeSlideId
          ));
        }
      }

      if (activeIndex < 0) activeIndex = 0;

      const nextIndex = (activeIndex + direction + selectors.length) % selectors.length;
      triggerMagicZoomSelector(container, selectors, nextIndex);
      syncThumbSliderToIndex(container, nextIndex);
    }

    function initThumbSlider(container) {
      if (window.innerWidth < 768) return;
      const sc = container.querySelector('.MagicToolboxSelectorsContainer');
      if (!sc || sc._thumbSlider) return;
      if (!window.theme || typeof window.theme.Slideshow !== 'function') return;

      sc._thumbSlider = new theme.Slideshow(sc, {
        wrapAround: true,
        prevNextButtons: false,
        pageDots: false,
        draggable: true,
        cellAlign: 'left',
        setGallerySize: false,
      });

      function changeMainImageToIndex(index) {
        const selectors = getMagicZoomSelectors(container);
        if (!selectors.length) return;

        setActiveMagicZoomSelector(selectors, index);

        if (window.MagicZoom && typeof window.MagicZoom.switchTo === 'function') {
          const zoomEl = container.querySelector('.MagicZoomPlus');
          const zoomId = zoomEl ? zoomEl.getAttribute('id') : null;
          const mzThumbs = Array.from(container.querySelectorAll('.mz-thumb'));
          const matchingThumb = mzThumbs[index];
          if (zoomId && matchingThumb) {
            try { window.MagicZoom.switchTo(zoomId, matchingThumb); } catch (e) { /* ignore */ }
            return;
          }
        }

        const targetSelector = selectors[index];
        if (targetSelector) forceMagicZoomMainImage(container, targetSelector);
      }

      // Wire custom prev/next arrow buttons
      const wrap = sc.closest('.products-boxes-thumb-wrap');
      if (wrap) {
        const prevBtn = wrap.querySelector('.products-boxes-thumb-arrow--prev');
        const nextBtn = wrap.querySelector('.products-boxes-thumb-arrow--next');
        if (prevBtn) {
          prevBtn.addEventListener('click', (e) => {
            e.preventDefault();
            sc._thumbSlider.slideshow.previous();
            changeMainImageToIndex(sc._thumbSlider.slideshow.selectedIndex);
          });
        }
        if (nextBtn) {
          nextBtn.addEventListener('click', (e) => {
            e.preventDefault();
            sc._thumbSlider.slideshow.next();
            changeMainImageToIndex(sc._thumbSlider.slideshow.selectedIndex);
          });
        }
      }

      // Thumbnail click → change main image (Flickity intercepts regular clicks)
      sc._thumbSlider.slideshow.on('staticClick', (event, pointer, cellElement, cellIndex) => {
        if (cellElement === undefined || cellIndex === undefined) return;
        changeMainImageToIndex(cellIndex);
      });
    }

    function syncThumbSliderToIndex(container, index) {
      const sc = container.querySelector('.MagicToolboxSelectorsContainer');
      if (!sc || !sc._thumbSlider || index < 0) return;
      sc._thumbSlider.goToSlide(index);
    }

    function observeMagicZoomNavigation(container) {
      if (container._mzNavObserver) return;

      let lastIndex = -1;

      const observer = new MutationObserver(() => {
        let activeIndex = -1;

        // MagicZoom-generated .mz-thumb elements
        const mzThumbs = Array.from(container.querySelectorAll('.mz-thumb'));
        if (mzThumbs.length) {
          activeIndex = mzThumbs.findIndex((t) => t.classList.contains('mz-thumb-selected'));
        } else {
          // Custom <a> selectors — MagicZoom sets mz-thumb-selected on them during swipe
          const selectors = getMagicZoomSelectors(container);
          activeIndex = selectors.findIndex((s) => s.classList.contains('mz-thumb-selected'));
        }

        if (activeIndex < 0 || activeIndex === lastIndex) return;
        lastIndex = activeIndex;
        setActiveMagicZoomSelector(getMagicZoomSelectors(container), activeIndex);
        syncThumbSliderToIndex(container, activeIndex);
      });

      observer.observe(container, { subtree: true, attributes: true, attributeFilter: ['class'] });
      container._mzNavObserver = observer;
    }

    function navigateMetafieldGallery(container, index) {
      const selectors = Array.from(container.querySelectorAll('.MagicToolboxSelectorsContainer a[data-slide-id]'));
      if (!selectors.length) return;
      const clampedIndex = ((index % selectors.length) + selectors.length) % selectors.length;
      const target = selectors[clampedIndex];
      if (!target) return;

      container.dataset.mfIndex = String(clampedIndex);
      selectors.forEach((s, i) => s.classList.toggle('active-magic-selector', i === clampedIndex));

      // Scroll container to keep active thumbnail centred
      const sc = container.querySelector('.MagicToolboxSelectorsContainer');
      if (sc) {
        const THUMB_W = 50;
        const GAP = 6;
        const step = THUMB_W + GAP;
        const idealScrollLeft = clampedIndex * step - (sc.clientWidth - THUMB_W) / 2;
        sc.scrollLeft = Math.max(0, idealScrollLeft);
      }

      const zoomLink = container.querySelector('.MagicZoomPlus');
      if (!zoomLink) return;

      // Update the main zoom image directly — MagicZoom.switchTo() doesn't reliably
      // recognize our hand-built thumbnail markup, so don't depend on it alone.
      const mainImg = zoomLink.querySelector('img');
      if (mainImg) {
        const dataImage = target.getAttribute('data-image');
        const dataImage2x = target.getAttribute('data-image-2x');
        const dataZoom2x = target.getAttribute('data-zoom-image-2x');
        const thumbImg = target.querySelector('img');
        const alt = thumbImg ? (thumbImg.getAttribute('alt') || '') : '';

        if (target.getAttribute('href')) zoomLink.setAttribute('href', target.getAttribute('href'));
        if (dataImage) zoomLink.setAttribute('data-image', dataImage);
        if (dataImage2x) zoomLink.setAttribute('data-image-2x', dataImage2x);
        else zoomLink.removeAttribute('data-image-2x');
        if (dataZoom2x) zoomLink.setAttribute('data-zoom-image-2x', dataZoom2x);
        else zoomLink.removeAttribute('data-zoom-image-2x');

        // Preload the target image first so the current one stays fully visible
        // (no blank/blackout) while the new one downloads; only fade once it's ready.
        const swapId = (mainImg._swapId || 0) + 1;
        mainImg._swapId = swapId;

        const applySwap = () => {
          if (mainImg._swapId !== swapId) return;
          mainImg.style.opacity = '0';
          window.setTimeout(() => {
            if (mainImg._swapId !== swapId) return;
            if (dataImage) mainImg.setAttribute('src', dataImage);
            if (dataImage2x) mainImg.setAttribute('srcset', dataImage2x + ' 2x');
            else mainImg.removeAttribute('srcset');
            mainImg.setAttribute('alt', alt);
            window.requestAnimationFrame(() => {
              mainImg.style.opacity = '1';
            });
          }, 200);
        };

        if (dataImage) {
          const preloader = new Image();
          preloader.onload = applySwap;
          preloader.onerror = applySwap;
          preloader.src = dataImage;
        } else {
          applySwap();
        }
      }

      // Let MagicZoom know the active thumb changed (for its own hover-zoom state).
      // switchTo() doesn't reliably recognize our hand-built thumbnail markup, so also
      // force a refresh — otherwise MagicZoom keeps hover-zooming the stale cached image.
      const zoomId = zoomLink.getAttribute('id');
      if (zoomId && window.MagicZoom) {
        if (typeof window.MagicZoom.switchTo === 'function') {
          try { window.MagicZoom.switchTo(zoomId, target); } catch (e) { /* ignore */ }
        }
        if (typeof window.MagicZoom.refresh === 'function') {
          try { window.MagicZoom.refresh(zoomId); } catch (e) { /* ignore */ }
        }
      }
    }

    function setupMagicZoomArrowFallback(panelContainer) {
      if (!panelContainer) return;

      // Self-contained navigation for metafield galleries
      panelContainer.querySelectorAll('[data-metafield-gallery]').forEach((mfContainer) => {
        if (mfContainer._mfNavBound) return;
        mfContainer._mfNavBound = true;

        mfContainer.addEventListener('click', (event) => {
          const mainArrow = event.target.closest('.MagicToolboxSlides-arrow');
          const thumbArrow = event.target.closest('.products-boxes-thumb-arrow');
          const thumb = event.target.closest('.MagicToolboxSelectorsContainer a');
          if (!mainArrow && !thumbArrow && !thumb) return;

          event.preventDefault();
          event.stopImmediatePropagation();

          if (mainArrow || thumbArrow) {
            const count = parseInt(mfContainer.dataset.mfCount || '0', 10);
            if (!count) return;
            const current = parseInt(mfContainer.dataset.mfIndex || '0', 10);
            const el = mainArrow || thumbArrow;
            const forward = el.classList.contains('magic-next') || el.classList.contains('products-boxes-thumb-arrow--next');
            navigateMetafieldGallery(mfContainer, current + (forward ? 1 : -1));
          } else {
            const selectors = Array.from(mfContainer.querySelectorAll('.MagicToolboxSelectorsContainer a[data-slide-id]'));
            const index = selectors.indexOf(thumb);
            if (index >= 0) navigateMetafieldGallery(mfContainer, index);
          }
        }, true);
      });

      const arrows = Array.from(panelContainer.querySelectorAll('.MagicToolboxSlides .MagicToolboxSlides-arrow'));
      arrows.forEach((arrow) => {
        if (arrow.dataset.productsBoxesArrowBound === 'true') return;
        if (arrow.closest('[data-metafield-gallery]')) return; // handled above
        arrow.dataset.productsBoxesArrowBound = 'true';

        arrow.addEventListener('click', (event) => {
          event.preventDefault();
          event.stopPropagation();

          const parentTarget = arrow.closest('.MagicToolboxContainer');
          if (!parentTarget) return;

          const forward = arrow.classList.contains('magic-next');

          if (window.MagicZoom && typeof window.MagicZoom.switchTo === 'function') {
            const currentSlide = parentTarget.querySelector('.mz-thumb.mz-thumb-selected');
            if (currentSlide) {
              let slideToLoad = forward ? currentSlide.nextElementSibling : currentSlide.previousElementSibling;
              if (forward && !slideToLoad) {
                slideToLoad = parentTarget.querySelector('.mz-thumb');
              }
              if (!forward && !slideToLoad) {
                slideToLoad = currentSlide.parentElement ? currentSlide.parentElement.lastElementChild : null;
              }
              if (slideToLoad) {
                const zoomEl = parentTarget.querySelector('.MagicZoomPlus');
                const zoomId = zoomEl ? zoomEl.getAttribute('id') : null;
                if (zoomId) {
                  const allThumbs = Array.from(currentSlide.parentElement.querySelectorAll('.mz-thumb'));
                  const nextIndex = allThumbs.indexOf(slideToLoad);
                  try { window.MagicZoom.switchTo(zoomId, slideToLoad); } catch (e) { /* ignore */ }
                  setActiveMagicZoomSelector(getMagicZoomSelectors(parentTarget), nextIndex);
                  syncThumbSliderToIndex(parentTarget, nextIndex);
                  return;
                }
              }
            }
          }

          moveMagicZoomByArrow(parentTarget, forward ? 1 : -1);
        });
      });

      panelContainer.querySelectorAll('.MagicToolboxContainer:not([data-metafield-gallery])').forEach((container) => {
        observeMagicZoomNavigation(container);
        initThumbSlider(container);
      });
    }

    function renderProductPanel(section, key, panelTemplateByKey) {
      const panelContainer = section.querySelector('[data-active-product-panel]');
      if (!panelContainer) return;

      const template = panelTemplateByKey.get(key);
      panelContainer.innerHTML = template ? template.innerHTML : '';
      executePanelScripts(panelContainer);
      refreshThirdPartyWidgets(panelContainer);
    }

    function escapeHtml(value) {
      if (value === null || value === undefined) return '';

      return String(value)
        .replace(/&/g, '&amp;')
        .replace(/</g, '&lt;')
        .replace(/>/g, '&gt;')
        .replace(/"/g, '&quot;')
        .replace(/'/g, '&#39;');
    }

    function parseMoneyToCents(value) {
      if (value === null || value === undefined) return 0;

      const raw = String(value).trim();
      if (!raw) return 0;
      if (raw.toUpperCase() === 'FREE') return 0;

      let cleaned = raw.replace(/[^0-9,.\-]/g, '');
      if (!cleaned) return 0;

      if (cleaned.includes(',') && cleaned.includes('.')) {
        cleaned = cleaned.replace(/,/g, '');
      } else if (cleaned.includes(',')) {
        const commaParts = cleaned.split(',');
        if (commaParts.length === 2 && commaParts[1].length <= 2) {
          cleaned = cleaned.replace(',', '.');
        } else {
          cleaned = cleaned.replace(/,/g, '');
        }
      }

      const parsed = Number.parseFloat(cleaned);
      if (Number.isNaN(parsed)) return 0;

      return Math.round(parsed * 100);
    }

    function normalizeSelectionId(value) {
      if (value === null || value === undefined) return '';
      return String(value).trim();
    }

    function buildBundleMappingKey(mainProductId, giftProductId) {
      const normalizedMainProductId = normalizeSelectionId(mainProductId);
      const normalizedGiftProductId = normalizeSelectionId(giftProductId);
      if (!normalizedMainProductId || !normalizedGiftProductId) return '';

      return `${normalizedMainProductId}::${normalizedGiftProductId}`;
    }

    function getProductsBoxesState(section) {
      if (!section._productsBoxesState) {
        section._productsBoxesState = {
          selectedMainProductId: '',
          selectedGiftProductId: '',
          selectedBundleMapping: null,
        };
      }

      return section._productsBoxesState;
    }

    function formatMoneyFromCents(cents) {
      const amount = Number(cents || 0);
      const sign = amount < 0 ? '-' : '';
      const value = Math.abs(amount) / 100;
      const fixed = value.toFixed(2).replace(/\.00$/, '');
      return `${sign}$${fixed}`;
    }

    function getRowCents(rowElement, type) {
      const dataKey = type === 'compare' ? 'compareCents' : 'priceCents';
      const spanSelector = type === 'compare'
        ? '.products-boxes__order-row-compare'
        : '.products-boxes__order-row-price';

      const datasetValue = Number.parseInt(rowElement.dataset[dataKey] || '', 10);
      if (Number.isFinite(datasetValue)) return datasetValue;

      const textElement = rowElement.querySelector(spanSelector);
      return parseMoneyToCents(textElement ? textElement.textContent : '');
    }

    function updateOrderTotals(section) {
      const rows = Array.from(section.querySelectorAll('.products-boxes__order-row'))
        .filter((row) => row.dataset.includeInTotal !== 'false' && !row.classList.contains('is-empty'));

      const totals = rows.reduce((acc, row) => {
        acc.compare += getRowCents(row, 'compare');
        acc.price += getRowCents(row, 'price');
        return acc;
      }, { compare: 0, price: 0 });

      const compareText = totals.compare > 0 ? formatMoneyFromCents(totals.compare) : '';
      const priceText = formatMoneyFromCents(totals.price);
      const hasCompare = totals.compare > totals.price;

      const totalCompare = section.querySelector('[data-order-total-compare]');
      const totalPrice = section.querySelector('[data-order-total-price]');
      const ctaCompare = section.querySelector('[data-order-action-total-compare]');
      const ctaPrice = section.querySelector('[data-order-action-total-price]');
      const ctaDivider = section.querySelector('.products-boxes__order-button-divider');

      if (totalCompare) {
        totalCompare.textContent = hasCompare ? compareText : '';
        totalCompare.classList.toggle('is-hidden', !hasCompare);
      }
      if (totalPrice) totalPrice.textContent = priceText;
      if (ctaCompare) {
        ctaCompare.textContent = hasCompare ? compareText : '';
        ctaCompare.classList.toggle('is-hidden', !hasCompare);
      }
      if (ctaPrice) ctaPrice.textContent = priceText;
      if (ctaDivider) ctaDivider.classList.toggle('is-hidden', !hasCompare);
    }

    function buildAddItemsPayload(section) {
      const rowItems = [];
      const sectionState = getProductsBoxesState(section);

      function appendItemFromData(itemData, fallbackBundleId) {
        if (!itemData) return false;

        const variantId = Number.parseInt(itemData.variant_id, 10);
        if (!Number.isFinite(variantId) || variantId <= 0) return false;

        const rowBundleId = String(itemData.bundle_id || fallbackBundleId || '').trim();
        const item = { id: variantId, quantity: 1 };
        if (rowBundleId) {
          item.properties = { _bundle_id: rowBundleId };
        }
        rowItems.push(item);
        return true;
      }

      if (sectionState.selectedBundleMapping && sectionState.selectedBundleMapping.order_row) {
        appendItemFromData(sectionState.selectedBundleMapping.order_row, 'try_rasa_hidden_bundle');
      } else {
        const mainRow = section.querySelector('[data-order-row-main]');
        if (mainRow && !mainRow.classList.contains('is-empty')) {
          appendItemFromData({
            variant_id: mainRow.dataset.variantId,
            bundle_id: mainRow.dataset.bundleId,
          });
        }
      }

      const groupedItemsMap = new Map();

      rowItems.forEach((item) => {
        const bundleId = item.properties && item.properties._bundle_id
          ? item.properties._bundle_id
          : '';
        const mapKey = `${item.id}::${bundleId}`;
        const existingItem = groupedItemsMap.get(mapKey);

        if (existingItem) {
          existingItem.quantity += item.quantity;
          return;
        }

        groupedItemsMap.set(mapKey, Object.assign({}, item));
      });

      return Array.from(groupedItemsMap.values());
    }

    function clearProductsBoxesDiscountState() {
      try {
        if (!window.localStorage) return;
        window.localStorage.removeItem(PRODUCTS_BOXES_DISCOUNT_STATE_KEY);
      } catch (error) {
        console.warn('Products Boxes: failed to clear discount state', error);
      }
    }

    function saveProductsBoxesDiscountState(variantItems) {
      try {
        if (!window.localStorage) return;

        const uniqueVariantIds = Array.from(new Set(
          (variantItems || [])
            .map((item) => String(item.id || '').trim())
            .filter(Boolean)
        ));

        if (!uniqueVariantIds.length) {
          clearProductsBoxesDiscountState();
          return;
        }

        window.localStorage.setItem(PRODUCTS_BOXES_DISCOUNT_STATE_KEY, JSON.stringify({
          active: true,
          variantIds: uniqueVariantIds,
          updatedAt: Date.now(),
        }));
      } catch (error) {
        console.warn('Products Boxes: failed to save discount state', error);
      }
    }

    function getConfiguredDiscountCodes(section) {
      const rawCodes = [
        section.dataset.orderDiscountCode1 || '',
        section.dataset.orderDiscountCode2 || '',
      ];

      const uniqueCodes = [];
      rawCodes.forEach((code) => {
        const cleanedCode = String(code).replace(/,/g, '').trim();
        if (!cleanedCode) return;
        if (uniqueCodes.includes(cleanedCode)) return;
        uniqueCodes.push(cleanedCode);
      });

      return uniqueCodes;
    }

    function buildDiscountCheckoutUrl(section) {
      const rootPath = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
      return `${rootPath}checkout`;
    }

    async function applyConfiguredDiscountCodesToCart(section, discountCodes) {
      if (!discountCodes || !discountCodes.length) return false;

      const rootPath = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
      const updateUrl = `${rootPath}cart/update.js`;
      const response = await fetch(updateUrl, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Accept': 'application/json',
        },
        body: JSON.stringify({
          discount: discountCodes.join(','),
        }),
      });

      return response.ok;
    }

    async function addOrderRowsToCart(section) {
      const button = section.querySelector('[data-order-add-all]');
      if (!button) return;

      const items = buildAddItemsPayload(section);
      if (!items.length) return;
      const discountCodes = getConfiguredDiscountCodes(section);

      button.disabled = true;

      try {
        const response = await fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ items }),
        });

        if (!response.ok) {
          const errorBody = await response.json().catch(() => null);
          console.error('Products Boxes: cart/add.js rejected the request', response.status, errorBody, items);
          return;
        }

        const discountCheckoutUrl = buildDiscountCheckoutUrl(section);
        const shouldRedirectWithDiscounts = section.dataset.orderDiscountRedirect === 'true' && discountCodes.length && discountCheckoutUrl;
        const shouldRedirectDirectlyToCheckout = section.dataset.directCheckoutRedirect === 'true' && discountCheckoutUrl;
        if (shouldRedirectWithDiscounts) {
          await applyConfiguredDiscountCodesToCart(section, discountCodes);
          saveProductsBoxesDiscountState(items);
          window.location.href = discountCheckoutUrl;
          return;
        }

        if (shouldRedirectDirectlyToCheckout) {
          clearProductsBoxesDiscountState();
          window.location.href = discountCheckoutUrl;
          return;
        }

        clearProductsBoxesDiscountState();

        if (typeof window.SLIDECART_UPDATE === 'function') {
          window.SLIDECART_UPDATE(() => {
            if (typeof window.SLIDECART_OPEN === 'function') {
              window.SLIDECART_OPEN();
            }
          });
        }
      } catch (error) {
        console.error('Products Boxes: failed to add items to cart', error);
      } finally {
        button.disabled = false;
      }
    }

    function renderOrderRow(section, selector, rowData) {
      const rowElement = section.querySelector(selector);
      if (!rowElement) return;

      if (!rowData || !rowData.title) {
        rowElement.classList.add('is-empty');
        rowElement.innerHTML = '';
        delete rowElement.dataset.variantId;
        delete rowElement.dataset.bundleId;
        rowElement.dataset.addToCart = 'false';
        rowElement.dataset.compareCents = '0';
        rowElement.dataset.priceCents = '0';
        rowElement.dataset.includeInTotal = 'false';
        rowElement.style.removeProperty('background');
        if (rowElement.dataset.hideWhenEmpty === 'true') {
          rowElement.hidden = true;
        }
        return;
      }

      const safeTitle = escapeHtml(rowData.title);
      const safeTitleSuffix = escapeHtml(rowData.title_suffix || '');
      const safeSubtitle = escapeHtml(rowData.subtitle || '');
      const safeCompare = escapeHtml(rowData.compare_price || '');
      const safePrice = escapeHtml(rowData.price || '');
      const imageStyle = rowData.image_url
        ? ` style="background-image: url('${escapeHtml(rowData.image_url)}');"`
        : '';
      const subtitleHtml = safeSubtitle
        ? `<div class="products-boxes__order-row-subtitle">${safeSubtitle}</div>`
        : '';
      const compareHtml = safeCompare
        ? `<span class="products-boxes__order-row-compare">${safeCompare}</span>`
        : '';
      const titleSuffixHtml = safeTitleSuffix
        ? ` <span class="products-boxes__order-row-title-suffix">${safeTitleSuffix}</span>`
        : '';
      const freeClass = rowData.is_free ? ' is-free' : '';
      const compareCents = Number.isFinite(Number(rowData.compare_cents))
        ? Number(rowData.compare_cents)
        : parseMoneyToCents(rowData.compare_price || '');
      const priceCents = Number.isFinite(Number(rowData.price_cents))
        ? Number(rowData.price_cents)
        : parseMoneyToCents(rowData.price || '');

      rowElement.classList.remove('is-empty');
      rowElement.hidden = false;
      rowElement.dataset.compareCents = String(compareCents);
      rowElement.dataset.priceCents = String(priceCents);
      rowElement.dataset.addToCart = rowData.add_to_cart ? 'true' : 'false';
      rowElement.dataset.includeInTotal = rowData.include_in_total === false ? 'false' : 'true';
      if (rowData.bundle_id) {
        rowElement.dataset.bundleId = String(rowData.bundle_id);
      } else {
        delete rowElement.dataset.bundleId;
      }
      if (rowData.background_color) {
        rowElement.style.background = String(rowData.background_color);
      } else {
        rowElement.style.removeProperty('background');
      }
      if (rowData.variant_id) {
        rowElement.dataset.variantId = String(rowData.variant_id);
      } else {
        delete rowElement.dataset.variantId;
      }
      rowElement.innerHTML = `
        <div class="products-boxes__order-row-main">
          <div class="products-boxes__order-row-media"${imageStyle}></div>
          <div class="products-boxes__order-row-content">
            <div class="products-boxes__order-row-title">${safeTitle}${titleSuffixHtml}</div>
            ${subtitleHtml}
          </div>
        </div>
        <div class="products-boxes__order-row-prices">
          ${compareHtml}
          <span class="products-boxes__order-row-price${freeClass}">${safePrice}</span>
        </div>
      `;
    }

    function updateBundleRow(section, bundleMappingByPair) {
      const sectionState = getProductsBoxesState(section);
      const mappingKey = buildBundleMappingKey(sectionState.selectedMainProductId, sectionState.selectedGiftProductId);
      const activeBundleMapping = mappingKey ? (bundleMappingByPair.get(mappingKey) || null) : null;

      sectionState.selectedBundleMapping = activeBundleMapping;
    }

    function activateCard(section, card, productDataByKey, productSealsByKey, panelTemplateByKey, bundleMappingByPair) {
      const cards = section.querySelectorAll('[data-product-card]');

      cards.forEach((item) => {
        const isActive = item === card;
        item.classList.toggle('is-active', isActive);
        item.setAttribute('aria-pressed', isActive ? 'true' : 'false');
      });

      const key = card.dataset.productKey;
      const data = productDataByKey.get(key) || { labels: [], quote_html: '', quote_various_html: '', order_row: null, seals: [] };
      const seals = (Array.isArray(data.seals) && data.seals.length)
        ? data.seals
        : (productSealsByKey.get(key) || []);
      const enrichedData = Object.assign({}, data, { seals });
      const sectionState = getProductsBoxesState(section);

      sectionState.selectedMainProductId = normalizeSelectionId(enrichedData.product_id);

      renderDetails(section, enrichedData);
      renderProductPanel(section, key, panelTemplateByKey);
      renderOrderRow(section, '[data-order-row-main]', enrichedData.order_row);
      updateBundleRow(section, bundleMappingByPair);
      updateOrderTotals(section);
      notifyActiveProductChange(section, card, enrichedData);
    }

    function activateGiftCard(section, card, giftDataByKey, bundleMappingByPair) {
      const cards = section.querySelectorAll('[data-gift-card]');

      cards.forEach((item) => {
        const isActive = item === card;
        item.classList.toggle('is-active', isActive);
        item.setAttribute('aria-pressed', isActive ? 'true' : 'false');
      });

      const key = card.dataset.giftKey;
      const data = giftDataByKey.get(key) || { product_id: null, order_row: null };
      const sectionState = getProductsBoxesState(section);

      sectionState.selectedGiftProductId = normalizeSelectionId(data.product_id);
      renderOrderRow(section, '[data-order-row-gift]', data.order_row);
      updateBundleRow(section, bundleMappingByPair);
      updateOrderTotals(section);
    }

    function reparentProductsBoxesBlocks(section) {
      const staging = section.querySelector('[data-products-boxes-block-staging]');
      if (!staging) return;

      const cardsContainer = section.querySelector('[data-products-boxes-cards]');
      const giftsContainer = section.querySelector('[data-products-boxes-gifts]');
      const bundleContainer = section.querySelector('[data-products-boxes-bundle-mappings]');

      if (cardsContainer) {
        Array.from(staging.querySelectorAll('[data-product-block]')).forEach((el) => {
          cardsContainer.appendChild(el);
        });
      }
      if (giftsContainer) {
        Array.from(staging.querySelectorAll('[data-gift-block]')).forEach((el) => {
          giftsContainer.appendChild(el);
        });
      }
      if (bundleContainer) {
        Array.from(staging.querySelectorAll('[data-bundle-mapping]')).forEach((el) => {
          bundleContainer.appendChild(el);
        });
      }
    }

    function finalizeMetafieldGalleryContainer(container) {
      const thumbs = Array.from(container.querySelectorAll('.MagicToolboxSelectorsContainer a'));
      const count = thumbs.length;

      container.dataset.mfCount = String(count);
      container.classList.toggle('no-thumbnails', count < 2);

      const thumbWrap = container.querySelector('.products-boxes-thumb-wrap');
      const arrows = container.querySelectorAll('.MagicToolboxSlides .MagicToolboxSlides-arrow');
      if (thumbWrap) thumbWrap.style.display = count < 2 ? 'none' : '';
      arrows.forEach((arrow) => { arrow.style.display = count < 2 ? 'none' : ''; });

      let activeThumb = container.querySelector('.active-magic-selector');
      if (count && !activeThumb) {
        activeThumb = thumbs[0];
        activeThumb.classList.add('active-magic-selector');
      }
      if (activeThumb) forceMagicZoomMainImage(container, activeThumb);

      thumbs.forEach((thumb, index) => {
        const base = (thumb.getAttribute('aria-label') || 'Product image thumbnail').replace(/\s+\d+$/, '');
        thumb.setAttribute('aria-label', `${base} ${index + 1}`);
      });
    }

    async function initProductsBoxesSection(section) {
      if (!section || section.dataset.productsBoxesInitialized === 'true') return;
      section.dataset.productsBoxesInitialized = 'true';

      reparentProductsBoxesBlocks(section);

      const cards = Array.from(section.querySelectorAll('[data-product-card]'));
      if (!cards.length) return;

      const productDataByKey = new Map();
      section.querySelectorAll('[data-product-json]').forEach((scriptTag) => {
        productDataByKey.set(scriptTag.dataset.productKey, parseProductJson(scriptTag));
      });

      const productSealsByKey = new Map();
      section.querySelectorAll('[data-product-seals-json]').forEach((scriptTag) => {
        productSealsByKey.set(scriptTag.dataset.productKey, parseProductSealsJson(scriptTag));
      });

      const panelTemplateByKey = new Map();
      section.querySelectorAll('[data-product-panel-template]').forEach((template) => {
        template.content.querySelectorAll('[data-metafield-gallery]').forEach(finalizeMetafieldGalleryContainer);
        panelTemplateByKey.set(template.dataset.productKey, template);
      });

      const giftDataByKey = new Map();
      section.querySelectorAll('[data-gift-json]').forEach((scriptTag) => {
        giftDataByKey.set(scriptTag.dataset.giftKey, parseGiftJson(scriptTag));
      });

      const bundleMappingByPair = new Map();
      section.querySelectorAll('[data-bundle-mapping]').forEach((scriptTag) => {
        const mapping = parseBundleMappingJson(scriptTag);
        const mappingKey = buildBundleMappingKey(mapping.main_product_id, mapping.gift_product_id);
        if (!mappingKey || !mapping.order_row || !mapping.order_row.variant_id) return;

        bundleMappingByPair.set(mappingKey, mapping);
      });

      const giftCards = Array.from(section.querySelectorAll('[data-gift-card]'));

      cards.forEach((card) => {
        card.addEventListener('click', async () => {
          await ensureMagicZoomReady(section);
          activateCard(section, card, productDataByKey, productSealsByKey, panelTemplateByKey, bundleMappingByPair);
        });
      });

      giftCards.forEach((card) => {
        card.addEventListener('click', () => {
          activateGiftCard(section, card, giftDataByKey, bundleMappingByPair);
        });
      });

      const activeCard = cards.find((card) => card.classList.contains('is-active')) || cards[0];
      await ensureMagicZoomReady(section);
      activateCard(section, activeCard, productDataByKey, productSealsByKey, panelTemplateByKey, bundleMappingByPair);

      if (giftCards.length) {
        const activeGiftCard = giftCards.find((card) => card.classList.contains('is-active')) || giftCards[0];
        activateGiftCard(section, activeGiftCard, giftDataByKey, bundleMappingByPair);
      } else {
        updateBundleRow(section, bundleMappingByPair);
        const giftsHeading = section.querySelector('[data-order-action-gifts-heading]');
        if (giftsHeading) giftsHeading.hidden = true;
      }

      const addAllButton = section.querySelector('[data-order-add-all]');
      if (addAllButton) {
        addAllButton.addEventListener('click', () => {
          addOrderRowsToCart(section);
        });
      }

      updateOrderTotals(section);
    }

    function initAllProductsBoxes(root) {
      if (!root) return;

      if (root.matches && root.matches('[data-products-boxes]')) {
        initProductsBoxesSection(root);
      }

      root.querySelectorAll('[data-products-boxes]').forEach((section) => {
        initProductsBoxesSection(section);
      });
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', () => initAllProductsBoxes(document));
    } else {
      initAllProductsBoxes(document);
    }

    document.addEventListener('shopify:section:load', (event) => {
      initAllProductsBoxes(event.target);
    });
  })();
